import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import accessoryPacksSectionStyles from './AccessoryPacksSectionStyles';
import AccessoryPackItem from '../accessoryPackItem/AccessoryPackItem';
import SectionStatesWrapper from '../../../../../common/components/configuratorStates/SectionStatesWrapper';
import IFeaturesList from '../../../../model/IFeaturesList';
import Translation from '../../../../../common/components/translation/Translation';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';

export interface IAccessoryPacksSectionProps {
  error?: any;
  loading?: boolean;
  featuresList: IFeaturesList;
  onSelect?: (id: string) => void;
}

const AccessoryPacksSection: FunctionComponent<IAccessoryPacksSectionProps> = ({
  featuresList,
  onSelect,
  error,
  loading,
}) => {
  const { optimisticSelectedFeatures } = useCustomizeCarContext();
  const styles = accessoryPacksSectionStyles();
  const { features } = featuresList;

  const renderOptions = () => {
    return (
      <Box className={styles.container}>
        <Typography
          component="span"
          variant="caption"
          className={styles.label}
          data-test="accessory_pack:options:label"
        >
          <Translation id="trans__configurator__customise_page_options_section__section_subtitle" />
        </Typography>
        {features.map(feature => (
          <Box mb={3} key={feature.code}>
            <AccessoryPackItem
              id={feature.code}
              name={feature.name}
              prices={feature.prices}
              selected={optimisticSelectedFeatures?.includes(feature.code)}
              onClick={onSelect}
              onToggle={onSelect}
            />
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <SectionStatesWrapper loading={loading || !features?.length} error={error}>
      {renderOptions()}
    </SectionStatesWrapper>
  );
};

export default AccessoryPacksSection;
